import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "container-fluid" };
const _hoisted_2 = { class: "main gdwrapper container-fluid" };
const _hoisted_3 = { class: "nav col-l-3 col-m-3 col-12 row-2" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { class: "col-l-9 col-m-9 col-12 gdwrapper" };
import './assets/styles/main.scss';
import './assets/fonts/fontawesome.css';
import { useUserStore } from '@/libs/stores.ts';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const auth = useUserStore();
        return (_ctx, _cache) => {
            const _component_RouterLink = _resolveComponent("RouterLink");
            const _component_RouterView = _resolveComponent("RouterView");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[4] || (_cache[4] = _createStaticVNode("<header class=\"container-fluid\"><div class=\"gdwrapper\"><div class=\"col-l-4 col-m-3 col-6\"><img id=\"logo\" src=\"./RSC_Logo.png\"></div><div class=\"col-l-4 col-m-5 col-6\"><h1>CODA (beta)</h1><hr></div><div class=\"col-l-4 col-m-4 col-12 gdwrapper\"><div class=\"col-l-12 col-m-12 col-6 gdwrapper\"><div class=\"col-l-6 col-m-6 col-12\">Icon</div><div class=\"col-l-6 col-m-6 col-12\">SVG</div></div><div class=\"col-l-12 col-m-12 col-6\"><input id=\"searchsite\" placeholder=\"Search...\" aria-placeholder=\"Search...\"></div></div></div></header>", 1)),
                _createElementVNode("main", _hoisted_2, [
                    _createElementVNode("nav", _hoisted_3, [
                        _createElementVNode("ul", null, [
                            (!_unref(auth).user?.sub)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                                    _createVNode(_component_RouterLink, { to: "/" }, {
                                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                                            _createTextVNode("Login")
                                        ])),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(auth).user?.sub)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                                    _createVNode(_component_RouterLink, { to: "/songde/srsummary" }, {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createTextVNode("Current Registrations")
                                        ])),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(auth).user?.sub)
                                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                                    _createVNode(_component_RouterLink, { to: "/songde" }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode("Register Songs ")
                                        ])),
                                        _: 1
                                    })
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("li", null, [
                                _createVNode(_component_RouterLink, { to: "/about" }, {
                                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                                        _createTextVNode("About")
                                    ])),
                                    _: 1
                                })
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_RouterView)
                    ])
                ])
            ]));
        };
    }
});
